/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AidPurchaseFormEnum } from './aidPurchaseFormEnum';
import { BlankEnum } from './blankEnum';
import { NullEnum } from './nullEnum';

export interface ChildSupportMeasuresUpsert { 
    id?: number;
    supportingMeasures?: number;
    supportingMeasuresStart?: string;
    supportingMeasuresEnd?: string;
    aidPurchaseForm?: AidPurchaseFormEnum | BlankEnum | NullEnum;
    isFundingRequired?: boolean;
    /**
     * Actual date when the support measure provision started
     */
    actualProvisionStart?: string;
    /**
     * Actual date when the support measure provision ended (empty if still active)
     */
    actualProvisionEnd?: string;
}